export const CallIntelSettingsTrackingIds = {
  pmsSync: {
    syncOptionOff: 'call-intel-settings:pms-sync:sync-option-off',
    syncOptionManual: 'call-intel-settings:pms-sync:sync-option-manual',
    syncOptionAutomatic: 'call-intel-settings:pms-sync:sync-option-automatic',
    manageAllButton: 'call-intel-settings:pms-sync:manage-all-button',
    syncSettingHelpLink: 'call-intel-settings:pms-sync:sync-setting-help-link',
    saveButton: 'call-intel-settings:pms-sync:save-button',
    multiSaveButton: 'call-intel-settings:pms-sync:multi-save-button',
    dismissMultiModalButton: 'call-intel-settings:pms-sync:dismiss-multi-modal-button',
    multiSaveConfirmButton: 'call-intel-settings:pms-sync:multi-save-confirm-button',
    multiSaveCancelButton: 'call-intel-settings:pms-sync:multi-save-cancel-button',
  },
  createTaskSettings: {
    manageAllButton: 'call-intel-settings:create-task-settings:manage-all-button',
  },
};
